
import Vue from 'vue'
export default Vue.extend({
  // eslint-disable-next-line vue/require-prop-types
  props: ['error']
})

